class CartDrawerDiscountsHolidays extends HTMLElement {
  connectedCallback() {
    this.miniCart = document.querySelector('mini-cart');
    this.getInformation();
    this.howMobileDiscountGif();
  }

  getInformation() {
    const scriptTag = this.querySelector(".js-cart-drawer-discounts-holidays script");
    if (!scriptTag) return;

    let data;
    try {
      data = JSON.parse(scriptTag.textContent);
    } catch (err) {
      console.error("❌ Invalid JSON inside .js-cart-drawer-discounts-holidays script");
      return;
    }

    this.handleThresholds(data);
  }

  async handleThresholds(data) {
    const total = parseFloat(data.cart_total || 0);
    const thresholds = [
      { value: parseFloat(data.threshold_2), productIds: data.product_2 },
      { value: parseFloat(data.threshold_3), productIds: data.product_3 },
      { value: parseFloat(data.threshold_4), productIds: data.product_4 },
    ];

    // Find the highest threshold reached
    let matched = null;
    thresholds.forEach((t) => {
      if (total >= t.value) matched = t;
    });

    if (matched && matched.productIds) {
      const productIds = matched.productIds
        .split(',')
        .map(id => id.trim())
        .filter(id => id !== '');

      this.showDiscountGif();
      
      for (const id of productIds) {
        await this.addGiftProduct(id);
      }
    }
  }

  async addGiftProduct(productId) {
    try {
      const isCartPage = document.body.classList.contains('template-cart');

      // Determine which sections to update
      const sections = this.miniCart
        ? this.miniCart.getSectionsToRender().map((section) => section.id)
        : [];

      // On cart page, also include the main cart section for AJAX refresh
      if (isCartPage) {
        const cartSection = document.querySelector('cart-items, .cart__items');
        if (cartSection) {
          const cartSectionId = cartSection.dataset.id || 'main-cart-items';
          sections.push(cartSectionId);
        }
      }

      const body = JSON.stringify({
        id: productId,
        quantity: 1,
        properties: { _gift: "Holiday Gift" },
        sections,
        sections_url: window.location.pathname,
      });

      const response = await fetch(`${theme.routes.cart_add_url}`, {
        ...fetchConfig("javascript"),
        body,
      });

      const parsedState = await response.json();

      if (parsedState.status === 422) return;

      // 🟢 Refresh mini cart drawer
      if (this.miniCart && !isCartPage) {
        this.miniCart.renderContents(parsedState);
      }

      // 🟢 Refresh cart page via AJAX (no full reload)
      if (isCartPage) {
        this.renderCartPage(parsedState);
      }

      document.dispatchEvent(
        new CustomEvent("ajaxProduct:added", { detail: { product: parsedState } })
      );

    } catch (err) {
      console.error(` Failed to add gift (${productId}):`, err);
    }
  }

  renderCartPage(state) {
    const parser = new DOMParser();
    const html = parser.parseFromString(state.sections['main-cart-items'], 'text/html');
    const newCartItems = html.querySelector('#main-cart-items');
    const currentCartItems = document.querySelector('#main-cart-items');
    if (newCartItems && currentCartItems) {
      currentCartItems.innerHTML = newCartItems.innerHTML;
    }

    // Update cart total if exists
    if (state.sections['cart-footer']) {
      const htmlFooter = parser.parseFromString(state.sections['cart-footer'], 'text/html');
      const newFooter = htmlFooter.querySelector('#cart-footer');
      const currentFooter = document.querySelector('#cart-footer');
      if (newFooter && currentFooter) {
        currentFooter.innerHTML = newFooter.innerHTML;
      }
    }
  }

    showDiscountGif() {
      // Create element
      const gifBox = this;
      gifBox.classList.add('discount-gif');

      // Remove after 30 seconds
      setTimeout(() => {
      gifBox.classList.remove('discount-gif');
      }, 5000);
    }

    howMobileDiscountGif(){
      this.querySelector("summary")?.addEventListener("click", () => {
        this.querySelector('.mobile-cart-drawer-discounts-holidays').classList.add('discount-gif');
        setTimeout(() => {
        this.querySelector('.mobile-cart-drawer-discounts-holidays').classList.remove('discount-gif');
        }, 5000);
      });
    }


}

customElements.define("cart-drawer-discounts-holidays", CartDrawerDiscountsHolidays);

class RemoveHolidaysGiftProduct extends HTMLElement {
  connectedCallback() {
    const scriptTag = this.querySelector('script[type="application/json"]');
    if (!scriptTag) return;

    this.productData = JSON.parse(scriptTag.textContent);
    this.waitForCartItems();
  }

  waitForCartItems() {
    const interval = setInterval(() => {
      const cartItems = this.closest('cart-items');
      if (cartItems && typeof cartItems.updateQuantity === 'function') {
        clearInterval(interval);
        this.removeGifts(cartItems);
      }
    }, 300); 
  }

  removeGifts(cartItems) {
    let cartItemProducts = [
      this.productData.cart_item_tab_one_product,
      this.productData.cart_item_tab_two_product,
      this.productData.cart_item_tab_three_product
    ];

    cartItemProducts = cartItemProducts
      .filter(id => id && id !== "")
      .map(id => ({ id, qty: 0 }));

    if (cartItemProducts.length > 0) {
      cartItems.updateQuantity(null, null, null, cartItemProducts);
      // console.log("Removed gift products:", cartItemProducts);
    }
  }
}

window.customElements.define('remove-holidays-gift-product', RemoveHolidaysGiftProduct);
